// Estados de emisión tal como vienen de las fuentes/Jikan → etiqueta en español
const STATUS_LABELS = {
  airing:    'En emisión',
  finished:  'Finalizado',
  upcoming:  'Próximamente',
  concluido: 'Finalizado',
};

export const statusLabel = (status) => STATUS_LABELS[String(status).toLowerCase()] || status;
